import { IEventAggregationService, ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { InlineSearchAppUserKeyboardEvent } from '@studyportals/inlinesearch-interfaces';
import store from '@/store';

export class UserKeyBoardPlugin implements ISubscriber<InlineSearchAppUserKeyboardEvent>
{
	public initiate(): void {
		const eventAggregationService = this.getEventAggregationService();
		if (!eventAggregationService) return;

		eventAggregationService.subscribeTo(
			InlineSearchAppUserKeyboardEvent.EventType,
			this
		);
	}

	public notify(event: InlineSearchAppUserKeyboardEvent): void {
		this.handleKeyBoardInput(event);
	}

	private handleKeyBoardInput(event: InlineSearchAppUserKeyboardEvent): void {

		store.mutations.setUserKeyboardEvent(event.keyboardEvent);
	}

	private getEventAggregationService(): IEventAggregationService | undefined {
		return window.EventAggregationService;
	}
}